import React from "react";
import PropTypes from "prop-types";
import DropDown, { DropDownItem } from "MODULES/shared/components/DropDown";
import { Icon } from "MODULES/shared/components";
import { useCurrentUser } from "APP_ROOT/hooks";
import { ACCOUNTING, ADMIN } from "MODULES/users/constants";
import { PAID } from "MODULES/Commissions/constants";

const RowActions = ({
  commission,
  setCommission,
  setUpdateStatusModalOpen,
  setUpdateOverrideOpen
}) => {
  const open = () => {
    setUpdateStatusModalOpen(true);
    setCommission(commission);
  };

  const openOverrideForm = () => {
    setUpdateOverrideOpen(true);
    setCommission(commission);
  };

  const currentUser = useCurrentUser();

  return (
    <div>
      <DropDown icon="fa fa-fw fa-ellipsis-v" menuClass="dropdown-menu-right">
        <DropDownItem onClick={open}>
          <Icon name="pencil" fixed /> Update Status
        </DropDownItem>
        {[ADMIN, ACCOUNTING].includes(currentUser.role) &&
          commission.status !== PAID && (
            <DropDownItem onClick={openOverrideForm}>
              <Icon name="pencil" fixed /> Override
            </DropDownItem>
          )}
      </DropDown>
    </div>
  );
};

export default RowActions;

RowActions.propTypes = {
  commission: PropTypes.shape({}).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Commissions/components/Search/RowActions.jsx